import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { IObject } from 'src/app/models/+global';
import { ConfigurationService, ForceBaseUrl } from 'src/app/services/configuration/configuration.service';
import { EndpointFactory } from '../endpoint-factory.service';
import { firstValueFrom } from 'rxjs';
import { IConfigManager, IConfigResolve } from 'src/app/models/config-manager';

@Injectable({
    providedIn: 'root'
})
export class ConfigsEndpointService extends EndpointFactory {

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('config', force) + 'config';
    }

    constructor(http: HttpClient,
        configurations: ConfigurationService,
        injector: Injector) {
        super(http, configurations, injector, 'config', configurations.webAppApiBaseUrl);
    }

    getall(): Promise<any> {
        const url = `${this.getServiceBaseUrl('WEBAPI')}`;
        return this.http.get<string[]>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    getKey(key: string): Promise<string[]> {
        const url = `${this.configurations.baseUrl}config/${key}`;
        return this.http.get<string[]>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    resolve(key: string, req: IObject): Promise<string[]> {
        const url = `${this.configurations.baseUrl}config/${key}`;
        return this.http.post<string[]>(url, req).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    firstOrDefault(key: string, req: IObject): Promise<IConfigResolve> {
        const url = `${this.configurations.baseUrl}config/${key}/firstordefault`;
        return firstValueFrom(this.http.post<IConfigResolve>(url, req).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        ));
    }

    getById(id: string): Promise<IConfigManager> {
        const url = `${this.configurations.baseUrl}config/getByid/${id}`;
        return firstValueFrom(this.http.get<IConfigManager>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        ));
    }

    addConfig(config: any): Promise<any> {
        const url = `${this.getServiceBaseUrl('WEBAPI')}`;

        return this.http.post<any>(url, config).toPromise();
    }

    deleteConfig(config: any): Promise<any> {
        const url = `${this.getServiceBaseUrl('WEBAPI')}/${config.Id}`;
        return firstValueFrom(this.http.delete<any>(url));
    }


    updateConfig(config: any): Promise<any> {
        const url = `${this.getServiceBaseUrl('WEBAPI')}/${config.Id}`;

        return this.http.put<any>(url, config).toPromise();
    }
}
